// extracted by mini-css-extract-plugin
export default {"badgeList":"A4yLBU"};